import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useGetAmountSummaryFromFulfillment } from '../../../fulfillment-plans/amount-summary/use-get-amount-summary-from-fulfillment';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from '../messages';

const TaxPaid = ({ fulfillmentId }) => {
  const amountSummary = useGetAmountSummaryFromFulfillment(fulfillmentId);
  if (!amountSummary?.taxAmount) {
    return '';
  }
  const { value, code } = amountSummary.taxAmount;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

TaxPaid.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const taxPaid = {
  getMessageDescriptor: () => messages.taxPaid,
  name: <FormattedMessage {...messages.taxPaid} />,
  id: 'taxPaid',
  render: (data) => <TaxPaid fulfillmentId={data.id} />,
};
